<template>
  <v-dialog
    v-if="isModalActive"
    :value="isModalActive"
    max-width="1250"
    persistent
    @input="inputModal"
  >
    <v-card
      id="upgrade-modal-card"
      class="pt-2 pb-0 px-3"
      :class="{ 'pt-3': isMd }"
      :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : 'softBackgroundGrey'"
    >
      <v-card-text class="mb-0 pb-4 pt-2 px-4">
        <!-- <v-alert class="mt-1 mb-5 py-2 upgrade-modal-card-alert" color="rgb(239, 237, 226)">
          <b>
            ¡Celebramos nuevos precios! Disfruta de un 50% de descuento en los tres primeros meses
            de un plan de pago hasta el día 6 de agosto.
          </b>
        </v-alert> -->

        <div class="upgrade-modal-card-header pl-2 mt-1">
          <div class="items-flex justify-between">
            <div class="items-flex align-center">
              <h1>
                {{ $t('views.common.upgradeModal.upgradeAccount') }}
              </h1>
              <!-- <span class="monthly-yearly-text" :class="{ 'white--text': $vuetify.theme.dark }">
                {{ $t('views.common.upgradeModal.yearly') }}
              </span>
              <v-switch
                v-model="isMonthly"
                color="upgradeGreen"
                inset
                hide-details
                class="pa-0 my-0 mr-1 ml-3"
                :disabled="loading"
              />
              <span class="monthly-yearly-text" :class="{ 'white--text': $vuetify.theme.dark }">
                {{ $t('views.common.upgradeModal.monthly') }}
              </span>
              <div v-if="!isMd && !isMonthly">
                <v-chip color="upgradeGreen" class="ml-3 upgrade-modal-card-save-months">
                  <span class="black--text">
                    {{ $t('views.common.upgradeModal.save2Months') }}
                  </span>
                </v-chip>
              </div> -->
            </div>
            <div class="upgrade-modal-card-header-close">
              <a @click="openKeepFreeReasonModal">
                <v-icon size="25">mdi-close</v-icon>
              </a>
            </div>
          </div>

          <!-- <div class="mt-3 upgrade-modal-card-subtitle text-left">
            <p
              v-if="userStatusLimitsError === 'users.statusLimitsReached'"
              class="darkTextGrey--text my-0 py-0"
            >
              {{ $t('views.common.upgradeModal.statusLimitsReached') }}
            </p>

            <p v-if="user.status === 'TRIAL'" class="darkTextGrey--text my-0 py-0">
              {{ $t('views.common.upgradeModal.keepTrialDays1') }}
              {{ user.trialDays }} {{ $t('views.common.upgradeModal.keepTrialDays2') }}
            </p>
          </div> -->
        </div>

        <v-row class="mt-3">
          <!-- no plan -->
          <v-col
            cols="12"
            md="3"
            sm="12"
            order="1"
            order-md="4"
            class="my-0 py-0"
            :class="{ 'pr-3': !isMd, 'mt-3': isMd }"
          >
            <div v-if="!isMd" class="mt-7"></div>
            <v-card class="upgrade-modal-total-height mt-0 pa-0 elevation-0">
              <v-card-text class="upgrade-modal-total-height">
                <PlanCard
                  :disabled="loading || user.status !== 'NO_PLAN'"
                  :isMonthly="isMonthly"
                  plan="noPlan"
                  :showPlanTitle="true"
                  :showDisclaimer="false"
                  :allowedPlan="
                    allowedPlans.find((elem) => elem.plan === 'noPlan') &&
                    allowedPlans.find((elem) => elem.plan === 'noPlan').allowed
                  "
                  :limitOperations="getPlanLimit('noPlan').maxTotalOperations"
                  :limitTotalCost="getPlanLimit('noPlan').maxTotalCostWithComissionBaseCurrency"
                  @go="goPlan('noPlan')"
                />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- premium -->
          <v-col
            cols="12"
            md="3"
            sm="12"
            order="2"
            order-md="3"
            class="my-0 py-0"
            :class="{ 'pr-3': !isMd, 'mt-6': isMd }"
          >
            <div class="upgrade-modal-card-more-popular">
              {{ $t('views.common.upgradeModal.morePopular') }}
            </div>
            <v-card class="upgrade-modal-total-height mt-0 pa-0 elevation-0">
              <v-card-text class="upgrade-modal-total-height">
                <PlanCard
                  :disabled="
                    (loading && planSelected !== 'premium') || user.status === 'PLAN_PREMIUM'
                  "
                  :loading="loading && planSelected === 'premium'"
                  :isMonthly="isMonthly"
                  plan="premium"
                  :showPlanTitle="true"
                  :showDisclaimer="false"
                  :allowedPlan="
                    allowedPlans.find((elem) => elem.plan === 'premium') &&
                    allowedPlans.find((elem) => elem.plan === 'premium').allowed
                  "
                  :limitOperations="getPlanLimit('premium').maxTotalOperations"
                  :limitTotalCost="getPlanLimit('premium').maxTotalCostWithComissionBaseCurrency"
                  @go="goPlan('premium')"
                />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- pro -->
          <v-col
            cols="12"
            md="3"
            sm="12"
            order="3"
            order-md="2"
            class="my-0 py-0"
            :class="{ 'pr-3': !isMd, 'mt-6': isMd }"
          >
            <div class="mt-7"></div>
            <v-card class="upgrade-modal-total-height mt-0 pa-0 elevation-0">
              <v-card-text class="upgrade-modal-total-height">
                <PlanCard
                  :disabled="(loading && planSelected !== 'pro') || user.status === 'PLAN_PRO'"
                  :loading="loading && planSelected === 'pro'"
                  :isMonthly="isMonthly"
                  plan="pro"
                  :showPlanTitle="true"
                  :showDisclaimer="false"
                  :allowedPlan="
                    allowedPlans.find((elem) => elem.plan === 'pro') &&
                    allowedPlans.find((elem) => elem.plan === 'pro').allowed
                  "
                  :limitOperations="getPlanLimit('pro').maxTotalOperations"
                  :limitTotalCost="getPlanLimit('pro').maxTotalCostWithComissionBaseCurrency"
                  @go="goPlan('pro')"
                />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- unlimited -->
          <v-col
            cols="12"
            md="3"
            sm="12"
            order="4"
            order-md="1"
            class="my-0 py-0"
            :class="{ 'pr-3': !isMd, 'mt-6': isMd }"
          >
            <div class="mt-7"></div>
            <v-card class="upgrade-modal-total-height mt-0 pa-0 elevation-0">
              <v-card-text class="upgrade-modal-total-height">
                <PlanCard
                  :disabled="
                    (loading && planSelected !== 'unlimited') || user.status === 'PLAN_UNLIMITED'
                  "
                  :loading="loading && planSelected === 'unlimited'"
                  :isMonthly="isMonthly"
                  plan="unlimited"
                  :showPlanTitle="true"
                  :showDisclaimer="false"
                  :allowedPlan="
                    allowedPlans.find((elem) => elem.plan === 'unlimited') &&
                    allowedPlans.find((elem) => elem.plan === 'unlimited').allowed
                  "
                  :limitOperations="getPlanLimit('unlimited').maxTotalOperations"
                  :limitTotalCost="getPlanLimit('unlimited').maxTotalCostWithComissionBaseCurrency"
                  @go="goPlan('unlimited')"
                />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- custom -->
          <!-- <v-col
            cols="12"
            md="3"
            sm="12"
            class="my-0 py-0"
            :class="{ 'pr-3': !isMd, 'mt-6': isMd }"
          >
            <div class="mt-7"></div>
            <v-card class="upgrade-modal-total-height mt-0 pa-0 elevation-0">
              <v-card-text class="upgrade-modal-total-height">
                <PlanCard
                  :disabled="
                    (loading && planSelected !== 'custom') || user.status === 'PLAN_CUSTOM'
                  "
                  :loading="loading && planSelected === 'custom'"
                  :isMonthly="isMonthly"
                  plan="custom"
                  :showPlanTitle="true"
                  :showDisclaimer="false"
                  :allowedPlan="
                    allowedPlans.find((elem) => elem.plan === 'custom') &&
                    allowedPlans.find((elem) => elem.plan === 'custom').allowed
                  "
                  :limitOperations="getPlanLimit('pro').maxTotalOperations"
                  :limitTotalCost="getPlanLimit('pro').maxTotalCostWithComissionBaseCurrency"
                  @go="goPlan('custom')"
                />
              </v-card-text>
            </v-card>
          </v-col> -->
        </v-row>

        <p
          class="pricing-features-disclaimer mb-0 pb-0 mt-10"
          :class="{ 'dark_Textgrey--text': $vuetify.theme.dark }"
        >
          *
          <b>{{ $t('views.common.upgradeModal.cancelWheneverYouWant') }}</b>
        </p>
        <p
          v-if="user.status === 'TRIAL'"
          class="pricing-features-disclaimer mb-0 pb-0"
          :class="{ 'dark_Textgrey--text': $vuetify.theme.dark }"
        >
          <b>
            {{ $t('views.common.upgradeModal.keepTrialDays1') }} {{ user.trialDays }}
            {{ $t('views.common.upgradeModal.keepTrialDays2') }}
          </b>
        </p>
        <p
          class="pricing-features-disclaimer mb-0 pb-0"
          :class="{ 'dark_Textgrey--text': $vuetify.theme.dark }"
        >
          <span>
            ** {{ $t('views.common.upgradeModal.disclaimerStripe1') }}
            <a href="https://stripe.com" target="_blank" class="pricing-features-disclaimer-stripe">
              Stripe
            </a>
            {{ $t('views.common.upgradeModal.disclaimerStripe2') }}
          </span>
        </p>
      </v-card-text>
    </v-card>

    <KeepFreeReasonModal
      :isModalActive.sync="isKeepFreeReasonModalActive"
      @closeParentModal="closeModal"
    />
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import { get } from 'lodash'
import {
  getAllowedPlans,
  // canCreateKeepFreeReason
} from '@/lib/api.js'
import gtag from '@/lib/gtag'
import modalMixin from '@/views/components/core/modalMixin.js'
import BillingMixin from '@/views/components/account/BillingMixin.js'
import PlanCard from '@/views/components/common/upgrade/PlanCard'
import KeepFreeReasonModal from '@/views/components/common/upgrade/KeepFreeReasonModal'

export default {
  components: { PlanCard, KeepFreeReasonModal },
  mixins: [modalMixin, BillingMixin],
  props: {
    isIndex: {
      // if true, is included in Index.vue, so open with userStatusLimitsError
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    planSelected: null,
    loading: false,
    isMonthly: true,
    allowedPlans: [],
    isKeepFreeReasonModalActive: false,
  }),
  computed: {
    ...mapState(['user', 'userStatusLimitsError']),
    isMd() {
      return this.$vuetify.breakpoint.smAndDown
    },
    openModalUserStatusLimitsError() {
      return (
        this.userStatusLimitsError &&
        (this.userStatusLimitsError === 'users.statusLimitsReached' ||
          this.userStatusLimitsError === 'users.statusNotReadPermission')
      )
    },
  },
  watch: {
    userStatusLimitsError: {
      async handler() {
        if (this.isIndex && this.openModalUserStatusLimitsError) {
          this.$emit('update:isModalActive', true)
        }
      },
      immediate: true,
    },
    async isModalActive() {
      if (this.isModalActive) {
        this.loading = true
        const result = await getAllowedPlans()
        this.allowedPlans = result.data.allowedPlans
        this.loading = false

        gtag.pageview({
          pagePath: `/account/billing/upgrade`,
          pageTitle: `account|billing|upgrade`,
          pageContentGroup: 'modal',
          extraParams: {
            openFromLimitsError: !!this.userStatusLimitsError,
          },
        })
      }
    },
  },
  methods: {
    ...mapActions({
      setUserStatusLimitsError: 'SET_USER_STATUS_LIMITS_ERROR',
      updateUsersInfo: 'UPDATE_USERS_INFO',
    }),
    resetForm() {
      this.planSelected = null
      this.loading = false
      this.isMonthly = true
      if (this.openModalUserStatusLimitsError) this.setUserStatusLimitsError(null)
    },
    async goPlan(plan) {
      this.planSelected = plan

      gtag.pageview({
        pagePath: `/account/billing/upgrade/planSelected`,
        pageTitle: `account|billing|upgrade|planSelected`,
        pageContentGroup: 'modal',
        extraParams: {
          openFromLimitsError: !!this.userStatusLimitsError,
          plan,
          isMonthly: !!this.isMonthly,
        },
      })

      if (plan === 'noPlan') {
        this.openKeepFreeReasonModal()
        return
      }

      if (plan === 'custom') {
        window.open('https://www.filios.app/contacta/', '_blank')
        this.closeModal()
        return
      }

      if (
        ['PLAN_PREMIUM', 'PLAN_PRO', 'PLAN_UNLIMITED', 'PLAN_CUSTOM'].indexOf(this.user.status) >
          -1 ||
        (this.userAccountStripeSubscription &&
          ['incomplete'].indexOf(this.userAccountStripeSubscription.status) > -1)
      ) {
        this.goToCustomerPortal()
      } else {
        await this.subscriptionCheckout({ plan, isMonthly: this.isMonthly })
      }
    },
    async openKeepFreeReasonModal() {
      // this.loading = true

      // const result = await canCreateKeepFreeReason()
      // const canCreate = get(result, 'data.canCreate', false)

      // if (canCreate) {
      //   this.isKeepFreeReasonModalActive = true
      // } else {
      //   this.closeModal()
      // }

      // this.loading = false
      this.closeModal()
    },
    getPlanLimit(plan) {
      if (!plan || !this.allowedPlans) return null

      const allowedPlan = this.allowedPlans.find((elem) => elem.plan === plan)
      if (allowedPlan)
        return {
          maxTotalCostWithComissionBaseCurrency: allowedPlan.maxTotalCostWithComissionBaseCurrency,
          maxTotalOperations: allowedPlan.maxTotalOperations,
        }
      else return {}
    },
  },
}
</script>

<style lang="scss">
#upgrade-modal-card {
  h1 {
    font-size: 18px;
  }
  text-align: center;
  .items-flex {
    display: flex;
    &.justify-center {
      justify-content: center;
    }
    &.justify-between {
      justify-content: space-between;
    }
  }
  .upgrade-modal-total-height {
    height: 100%;
  }

  .upgrade-modal-card-alert {
    font-size: 17px;
  }

  .upgrade-modal-card-header {
    .upgrade-modal-card-header-yearmonth-centered {
      flex: 1;
      display: flex;
      justify-content: center;
      transform: translateX(20px); /*D element Width[if needed]*/
    }
    .monthly-yearly-text {
      font-weight: 700;
    }
  }

  .upgrade-modal-card-advise {
    text-align: center;
    .v-alert__content {
      font-size: 16px;
      font-weight: 400;
    }
  }

  .upgrade-modal-card-save-months {
    margin-bottom: 1px;
  }

  .upgrade-modal-card-more-popular {
    background: #7de9c5;
    color: black;
    font-weight: 500;
    font-size: 15px;
    border-radius: 5px 5px 0px 0px;
  }

  .upgrade-modal-card-upgrade-account {
    text-align: left;
    .upgrade-modal-card-upgrade-account-title {
      font-size: 22px;
      font-weight: 300;
    }
  }
  .upgrade-modal-card-subtitle {
    font-size: 15px;
    font-weight: 400;
  }

  .pricing-features-disclaimer {
    text-align: left;
    color: rgba(0, 0, 0, 0.38);
    font-size: 12px;
    line-height: 20px;
    .pricing-features-disclaimer-stripe {
      color: #8079fe;
    }
  }
}
</style>
